import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Studio } from "sanity";
import config from "../../sanity.config";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Studio config={config} />
  </StrictMode>
);
